import { render } from "./IngredientForm.vue?vue&type=template&id=aab09832&scoped=true"
import script from "./IngredientForm.vue?vue&type=script&lang=js"
export * from "./IngredientForm.vue?vue&type=script&lang=js"

import "./IngredientForm.vue?vue&type=style&index=0&id=aab09832&lang=scss&scoped=true"
import "./IngredientForm.vue?vue&type=style&index=1&id=aab09832&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab09832"]])

export default __exports__